module.exports = __webpack_public_path__ + "fonts/iconfont.ba57735d.woff";